import { CommonResponse, post } from './common.ts'

/**
 * board/login
 */
export const login = async (code: string): Promise<CommonResponse<null>> => {
  return await post('board/login', { code })
}
